
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 6c-.4-.4-1-.4-1.4 0L9 14.7l-2.6-2.6c-.3-.3-1-.5-1.4-.1s-.5 1-.1 1.4L8.3 17c.2.2.4.3.7.3s.5-.1.6-.3L19 7.4c.4-.4.4-1 0-1.4z"}})])
          )
        }
      }
    